module.exports = __webpack_public_path__ + "static/media/note_add_black_24dp.991f4eff.svg";